/*
 * Copyright (c) CIRROM 2025.
 */

export const THEMES = {
  DEFAULT: "DEFAULT",
  DARK: "DARK",
  LIGHT: "LIGHT",
  BLUE: "BLUE",
  GREEN: "GREEN",
  INDIGO: "INDIGO",
  CIRROM: "CIRROM",
};
